"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var reactstrap_1 = require("reactstrap");
var NavMenu_1 = require("./NavMenu");
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            challenge: "ICASSP2021"
        };
        _this.handleChallengeChange = _this.handleChallengeChange.bind(_this);
        _this.state = { challenge: 'ICASSP2021' };
        return _this;
    }
    Layout.prototype.handleChallengeChange = function (challengeChange) {
        var _this = this;
        this.setState(function (state) { return ({ challenge: challengeChange }); });
        this.setState(function () {
            console.log("Within setstate function setting the state");
            return {
                challenge: challengeChange
            };
        }, function () {
            console.log("state after async call is " + _this.state.challenge);
            _this.forceUpdate();
            _this.render();
        });
        //window.location.reload();
    };
    Layout.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(React.Fragment, null,
                React.createElement(NavMenu_1.default, { challenge: this.state.challenge, onChallengeChange: this.handleChallengeChange }),
                React.createElement(reactstrap_1.Container, { challenge: this.state.challenge }, this.props.children))));
    };
    return Layout;
}(React.Component));
exports.default = react_redux_1.connect()(Layout);
//# sourceMappingURL=Layout.js.map